import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { Briefcase, Loader2 } from 'lucide-react';

export const BusinessCoachPanel = ({ adviceQ, setAdviceQ, adviceResult, onAsk, loading }) => (
  <div className="max-w-3xl mx-auto space-y-6" data-testid="advice-panel">
    <Card className="card-tech p-8">
      <h2 className="text-2xl font-bold text-green-400 mb-2">
        <Briefcase className="w-6 h-6 inline mr-2" /> AI Business Coach
      </h2>
      <p className="text-green-300 mb-6">Get personalized business advice based on your revenue data and goals.</p>
      <Textarea value={adviceQ} onChange={e => setAdviceQ(e.target.value)}
        placeholder="e.g., How can I increase my conversion rate? What marketing channels should I focus on?"
        className="bg-black/50 border-green-500/30 text-green-300 min-h-24" rows={3} data-testid="advice-question-input" />
      <Button onClick={onAsk} disabled={loading || !adviceQ} className="btn-primary w-full py-4 mt-4" data-testid="advice-ask-button">
        {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Analyzing...</> : 'Get Business Advice'}
      </Button>
      {adviceResult && (
        <div className="mt-6 space-y-4" data-testid="advice-result">
          {adviceResult.user_stats && (
            <div className="grid grid-cols-2 gap-4">
              <div className="p-3 bg-green-500/10 rounded border border-green-500/20">
                <p className="text-green-400 text-sm">Your Revenue</p>
                <p className="text-xl font-bold text-green-500">${adviceResult.user_stats.total_revenue}</p>
              </div>
              <div className="p-3 bg-green-500/10 rounded border border-green-500/20">
                <p className="text-green-400 text-sm">Your Sales</p>
                <p className="text-xl font-bold text-green-500">{adviceResult.user_stats.total_sales}</p>
              </div>
            </div>
          )}
          <div className="p-4 bg-green-500/5 border border-green-500/20 rounded">
            <h4 className="text-green-400 font-semibold mb-2">AI Advice:</h4>
            <div className="text-green-300 whitespace-pre-wrap leading-relaxed">{adviceResult.advice}</div>
          </div>
        </div>
      )}
    </Card>
  </div>
);
